import { Product, ProductType } from '@inter-ikea-storageone/range';
import { convertProductToPart } from './sectionTransformer';

export const transformAdjustable = (products: Product[]): Product[] => {
  const productsClone = structuredClone(products);
  const adjustableShelves = productsClone.filter(p => p.type === ProductType.BOAXEL_ADJ_SHELF);
  const adjustableClothesRails = productsClone.filter(
    p => p.type === ProductType.BOAXEL_ADJ_CLOTHES_RAIL
  );

  [...adjustableShelves].forEach(replaceMscParts(productsClone));
  addSizeData([...adjustableShelves, ...adjustableClothesRails]);
  return productsClone;
};

const replaceMscParts = (productsClone: Product[]) => (adjustableProduct: Product) => {
  const realParts = adjustableProduct.parts.filter(p => !p.itemType.includes('MSC'));
  const product = productsClone.find(
    p => p.meta?.relatedArticle === adjustableProduct.coreProductId
  );

  if (!product) throw new Error('Could not find product');

  const missingPart = convertProductToPart(product);

  if (!missingPart.product?.valid) adjustableProduct.valid = false;
  else adjustableProduct.parts = [...realParts, missingPart];
};

// Adjustable products in our catalog have no size/comSize data, we add the data here.
// Setting it up in BRYGGA will mess with the bounding boxes for the entities.
const addSizeData = (products: Product[]) =>
  products.forEach(p => (p.communicatedDimensions = { width: 200, height: 0, depth: 0 }));
